export enum CompanyPayingService {
    TicketApp
}
